// extracted by mini-css-extract-plugin
export var form = "_dx-0";